module.exports = __webpack_public_path__ + "static/apto-213-n-f13a0028340cf7b46842a1c7e2c8f629.jpg";